export default __webpack_public_path__ + "static/media/logo.f35620a0.svg";